module.exports = __webpack_public_path__ + "img/logo.00824b17.png";